import { CardList, TextButtonLink } from '@maia/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { InsuranceCard } from '../../shared/insurance/insurance-card';
import { getInsurancesOptions } from '../insurances/queryOptions';
import { useDrawerStore } from './../../../stores/drawer.store';

export function InsuranceList() {
  const { guid } = useParams({
    from: '/_authenticated/customers/$guid/_layout',
  });
  const { data } = useSuspenseQuery(getInsurancesOptions(guid, { limit: 3 }));
  const { openDrawer } = useDrawerStore();

  return (
    <CardList
      title="Huidige verzekeringen"
      items={data.response}
      resource="huidige verzekeringen"
      render={(insurance) => (
        <InsuranceCard
          insurance={insurance}
          onOpen={() => openDrawer({ type: 'insurance', data: insurance })}
        />
      )}
      action={
        <TextButtonLink
          size="tiny"
          to="/customers/$guid/insurances"
          params={{ guid }}
        >
          Bekijk alles
        </TextButtonLink>
      }
    />
  );
}
